import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from '@widgets/widgets';

@Component({
  selector: 'lms-autoevaluation',
  templateUrl: './autoevaluation.component.html',
  styleUrls: ['./autoevaluation.component.scss']
})
export class AutoevaluationComponent implements WidgetComponent, OnInit {
  @Input() public data: any;
  public autoevaluation: any;
  public widgetId: string = '';
  public autoevaluationData: boolean = true;

  constructor() {}

  public ngOnInit(): void {
    this.calculeRatios();
  }

  public calculeRatios() {
    const autoevaluation = this.data.autoevaluations;
    const surveysCount = autoevaluation.surveysCount;
    const avgResponsesInitial = autoevaluation.avgPre;
    const avgResponsesFinal = autoevaluation.avgPost;
    const avgGlobal = autoevaluation.improvement;
    this.autoevaluation = {
      avgResponsesFinal,
      avgResponsesInitial,
      surveysCount,
      avgGlobal
    };
    this.autoevaluationData = !autoevaluation.empty;
  }
}
